import { useEffect, useState } from 'react';
import { SiteCloudStatus } from '../interfaces/survey.interface';
import { getSiteCloudStatus } from '../services/assessments';

const DEFAULT_STATUS: SiteCloudStatus = { site: false, cloud: false, both: false };

export default function useSiteCloudStatus(baselineId?: number | null) {
  const [status, setStatus] = useState<SiteCloudStatus>(DEFAULT_STATUS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!baselineId) {
      setStatus(DEFAULT_STATUS);
      setLoaded(true);
      return;
    }
    let cancelled = false;
    setLoaded(false);
    setStatus(DEFAULT_STATUS);
    getSiteCloudStatus(baselineId)
      .then(s => { if (!cancelled) setStatus(s); })
      .catch(err => console.error('Failed to fetch site/cloud status:', err))
      .finally(() => { if (!cancelled) setLoaded(true); });
    return () => { cancelled = true; };
  }, [baselineId]);

  return { status, loaded };
}
